import { atom } from "jotai";

export const rutaAtom = atom("home");
export const openModalOmitirAtom = atom(false);